import { PageShell, Section } from "@/components/PageShell";

export default function License() {
  return (
    <PageShell
      title="License"
      subtitle="What you receive when you purchase CommandCenterADHD and how it may be used."
      testid="license-page"
    >
      <Section heading="What you are purchasing">
        <p>
          Your purchase gives you access to the CommandCenterADHD Notion
          template and its included setup videos and community access. You are
          buying a personal license to duplicate the template into your own
          Notion workspace and use it for your own planning.
        </p>
      </Section>

      <Section heading="Personal, non transferable access">
        <p>
          Access is granted to the individual who purchased it and is tied to
          the email used at checkout. The license is personal and is not
          transferable or resellable. Please do not share your access link or
          your duplicated template with people who have not purchased.
        </p>
      </Section>

      <Section heading="Copying, sharing, and redistribution">
        <p>
          You may duplicate the template for your own use and make personal
          copies within your own workspace. You may not copy, share, resell,
          sublicense, publish, or redistribute the template, its structure, or
          its written content to others, whether for free or for payment.
        </p>
      </Section>

      <Section heading="Commercial use">
        <p>
          The template is licensed for personal planning use. Using the template
          as part of a paid service, packaging it into another product, or
          distributing it to clients or team members requires prior written
          permission. Contact support@commandcenteradhd.com to discuss commercial
          arrangements.
        </p>
      </Section>

      <Section heading="Ownership">
        <p>
          All original content, structure, wording, layout, logos, and branding
          in CommandCenterADHD remain the property of CommandCenterADHD. The
          license granted to you does not transfer any ownership of that
          intellectual property. Any content you create inside your own
          duplicated workspace remains yours.
        </p>
      </Section>

      <Section heading="Questions">
        <p>
          For anything about this license, email
          {" "}
          <a href="mailto:support@commandcenteradhd.com" className="font-semibold text-[#A8D5F5] hover:text-white">
            support@commandcenteradhd.com
          </a>
          .
        </p>
      </Section>
    </PageShell>
  );
}
